import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import PMBSelect from 'components/PMBSelect'
import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AlertCircle, Package, Plus } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardText,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
} from 'reactstrap'
import { URL_INVENTORY, URL_TRANSFER_INVENTORY } from 'utils/pathUrl'
import TransferInventoryItem from './components/TransferInventoryItem'
import { getPackingDetail } from './transferInventoryAction'
import {
  useLazyFetchInventoryQuery,
  useLazyFetchInventoryTransferQuery,
  useLazyFetchPackingQuery,
  useLazyFetchWarehousesQuery,
  usePostTransferMutation,
} from './transferInventoryApiSlice'

const FormTransferInventory = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const intl = useIntl()
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [isInventoryLoading, setIsInventoryLoading] = useState(false)
  const [listOptions, setListOptions] = useState([])
  const [listOptionsOriginatingWarehouse, setListOptionsOriginatingWarehouse] =
    useState([])
  const [listOptionsWarehouse, setListOptionsWarehouse] = useState([])
  const [errMsg, setErrMsg] = useState('')
  const [payload, setPayload] = useState(null)
  const [pics, setPics] = useState([])
  const hasPrefillData = Boolean(
    location.state &&
      (location.state.fromWarehouse ||
        (Array.isArray(location.state.transferItems) &&
          location.state.transferItems.length > 0)),
  )
  const [dismissPrefillAlert, setDismissPrefillAlert] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [createTransfer, resultTransfer] = usePostTransferMutation()
  const [getInventory, res] = useLazyFetchInventoryQuery()
  const [getGudang, resWarehouse] = useLazyFetchWarehousesQuery()
  const [getPacking, resPackings] = useLazyFetchPackingQuery()
  const [getTfInventori] = useLazyFetchInventoryTransferQuery()

  const formatAmount = (val) => {
    if (!val && val !== 0) return ''
    return intl.formatNumber(val, {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
  }

  const parseAmount = (value) => {
    if (!value && value !== 0) return 0
    return (
      parseFloat(
        value.toString().replace(/\./g, '').replace(',', '.'),
      ) || 0
    )
  }

  const handleAmountChange = (index, value) => {
    setErrMsg('')
    const numericValue = value === '' ? '' : parseAmount(value)
    setPics((prevPics) => {
      const updatedPics = [...prevPics]
      const current = updatedPics[index]
      if (current) {
        updatedPics[index] = {
          ...current,
          transferAmount: numericValue,
        }
      }
      return updatedPics
    })
  }

  const handleGroupItemAmountChange = (groupIndex, memberIndex, value) => {
    setErrMsg('')
    const numericValue = value === '' ? '' : parseAmount(value)
    setPics((prevPics) => {
      const updatedPics = [...prevPics]
      const group = updatedPics[groupIndex]
      if (group && group.items && group.items[memberIndex]) {
        const updatedMembers = [...group.items]
        updatedMembers[memberIndex] = {
          ...updatedMembers[memberIndex],
          transferAmount: numericValue,
        }
        updatedPics[groupIndex] = {
          ...group,
          items: updatedMembers,
        }
      }
      return updatedPics
    })
  }

  const handleToggleGroup = (index) => {
    setPics((prevPics) => {
      const updatedPics = [...prevPics]
      const current = updatedPics[index]
      if (current) {
        updatedPics[index] = {
          ...current,
          isExpanded: current.isExpanded === false,
        }
      }
      return updatedPics
    })
  }

  const loadGroupMembers = useCallback(
    async (groupId, targetIdx) => {
      try {
        const resDetail = await dispatch(getPackingDetail({ id: groupId }))
        const content =
          resDetail?.payload?.content || resDetail?.payload?.items || []
        setPics((prevPics) => {
          const next = [...prevPics]
          const idx =
            targetIdx !== undefined &&
            String(next[targetIdx]?.id) === String(groupId)
              ? targetIdx
              : next.findIndex(
                  (p) =>
                    p &&
                    String(p.id) === String(groupId) &&
                    p.isPacking,
                )

          if (idx !== -1 && next[idx]) {
            next[idx] = {
              ...next[idx],
              loadingItems: false,
              loadError: false,
              items: content.map((m) => {
                const name =
                  m?.item?.nameItem || m?.nameItem || m?.name || 'Komoditas'
                const unit = m?.unit || m?.item?.unit || ''
                const ownerCode = m?.ownerCode || '-'
                const lotCode =
                  m?.lots
                    ?.map((l) => l.codeLot || l.lotCode)
                    .filter(Boolean)
                    .join(', ') ||
                  m?.lotCode ||
                  '-'
                const photo = m?.item?.linkFoto || m?.linkFoto
                const amountVal = m?.amount ?? 0
                return {
                  id: m.id,
                  nameItem: name,
                  amount: amountVal,
                  transferAmount: amountVal,
                  unit,
                  ownerCode,
                  lotCode,
                  linkFoto: photo,
                }
              }),
            }
          }
          return next
        })
      } catch (error) {
        setPics((prevPics) => {
          const next = [...prevPics]
          const idx =
            targetIdx !== undefined &&
            String(next[targetIdx]?.id) === String(groupId)
              ? targetIdx
              : next.findIndex(
                  (p) =>
                    p &&
                    String(p.id) === String(groupId) &&
                    p.isPacking,
                )
          if (idx !== -1 && next[idx]) {
            next[idx] = {
              ...next[idx],
              loadingItems: false,
              loadError: true,
              items: [],
            }
          }
          return next
        })
        enqueueSnackbar('Gagal memuat detail inventori dalam grup.', {
          variant: 'error',
        })
      }
    },
    [dispatch, enqueueSnackbar],
  )

  const handleSelectOption = useCallback(
    (index, selectedOption) => {
      setErrMsg('')
      if (!selectedOption) return

      if (selectedOption.isPacking) {
        const newGroupItem = {
          id: selectedOption.id,
          value: selectedOption.id,
          nameItem:
            selectedOption.nameItem ||
            selectedOption.label ||
            selectedOption.name ||
            'Grup Inventori',
          label: selectedOption.label || selectedOption.nameItem,
          amount: selectedOption.amount || 0,
          unit: selectedOption.unit || '',
          isPacking: true,
          isExpanded: true,
          loadingItems: true,
          items: [],
        }

        setPics((prevPics) => {
          const next = [...prevPics]
          next[index] = newGroupItem
          return next
        })

        loadGroupMembers(selectedOption.id, index)
      } else {
        const newInventoryItem = {
          id: selectedOption.id,
          value: selectedOption.id,
          nameItem: selectedOption.nameItem,
          amount: selectedOption.amount ?? 0,
          transferAmount: selectedOption.amount ?? 0,
          unit: selectedOption.unit,
          ownerCode: selectedOption.ownerCode || '-',
          lotCode: selectedOption.lotCode || '-',
          lots: selectedOption.lots,
          photo: selectedOption.linkFoto,
          linkFoto: selectedOption.linkFoto,
          isPacking: false,
        }

        setPics((prevPics) => {
          const next = [...prevPics]
          next[index] = newInventoryItem
          return next
        })
      }
    },
    [loadGroupMembers],
  )

  const formatItemForPic = useCallback((item) => {
    if (item.isPacking) {
      const label =
        item.label || item.name || item.nameItem || 'Grup Inventori'
      return {
        id: item.id,
        value: item.id,
        nameItem: label,
        label,
        amount: item.amount || 0,
        unit: item.unit || '',
        isPacking: true,
        isExpanded: true,
        loadingItems: true,
        items: [],
      }
    }

    const name = item.item?.nameItem || item.nameItem || ''
    const unit = item.unit || item.item?.unit || ''
    const amountVal = item.transferAmount ?? item.amount ?? 0
    const ownerCode = item.ownerCode || '-'
    const lotCodes =
      item.lots
        ?.map((lot) => lot.codeLot || lot.lotCode)
        .filter(Boolean)
        .join(', ') ||
      item.lotCode ||
      '-'
    const photo = item.item?.linkFoto || item.linkFoto

    return {
      id: item.id,
      value: item.id,
      nameItem: name,
      amount: item.amount,
      transferAmount: amountVal,
      unit,
      ownerCode,
      lotCode: lotCodes,
      photo,
      linkFoto: photo,
      isPacking: false,
    }
  }, [])

  const handleSubmit = async () => {
    try {
      const inventories = []

      for (const e of pics) {
        if (!e || e === '') continue

        if (e?.isPacking) {
          if (Array.isArray(e?.items) && e.items.length > 0) {
            inventories.push(
              ...e.items.map((item) => ({
                id: item?.id,
                amount: item?.transferAmount ?? item?.amount,
              })),
            )
          } else {
            const resDetail = await dispatch(getPackingDetail({ id: e?.id }))
            const content =
              resDetail?.payload?.content || resDetail?.payload?.items || []
            if (content.length > 0) {
              inventories.push(
                ...content.map((item) => ({
                  id: item?.id,
                  amount: item?.transferAmount || item?.amount,
                })),
              )
            }
          }
        } else {
          inventories.push({
            id: e?.id,
            amount: e?.transferAmount ?? e?.amount,
          })
        }
      }

      if (inventories.length === 0) {
        setErrMsg('Tidak ada inventori yang valid untuk dipindahkan.')
        return
      }
      const fromWarehouseId =
        payload?.fromWarehouse?.id ?? payload?.fromWarehouse?.value
      const toWarehouseId =
        payload?.toWarehouse?.id ?? payload?.toWarehouse?.value

      const body = {
        fromWarehouseId: payload?.fromWarehouse?.id ?? null,
        toWarehouseId: payload?.toWarehouse?.id ?? null,
        note: payload?.note,
        transferNumber: payload?.transferNumber,
        inventories,
      }


      const result = await createTransfer(body)
      if (result?.error) {
        throw result
      } else {
        navigate(URL_TRANSFER_INVENTORY)
        enqueueSnackbar(`Pengiriman Inventori berhasil dibuat.`, {
          variant: 'success',
        })
        await getTfInventori({})
      }
    } catch (error) {
      setErrMsg(error?.error?.data?.message ?? error?.message)
    }
  }

  const handleAdd = () => {
    setErrMsg('')
    setPics((prev) => [...prev, ''])
  }

  const handleDelete = (index) => {
    setErrMsg('')
    setPics((prev) => prev.filter((_, i) => i !== index))
  }

  const getFilteredOptions = () => {
    const selectedKeys = new Set(
      pics
        ?.filter((p) => p && p.id)
        ?.map((p) => `${p.isPacking ? 'group' : 'inventory'}:${p.id}`),
    )

    const transformedOptions = listOptions
      ?.map((group) => {
        const groupOptions = group?.options || []
        return {
          ...group,
          options: groupOptions.map((option) => {
            const optionKey = `${option.isPacking ? 'group' : 'inventory'}:${option.id}`
            return {
              ...option,
              isDisabled: selectedKeys.has(optionKey),
            }
          }),
        }
      })
      ?.filter((group) => group.options && group.options.length > 0)

    return transformedOptions || []
  }

  const fetchInv = useCallback(
    async (warehouseId) => {
      try {
        setIsInventoryLoading(true)

        let resInv = await getInventory({
          isForTransaction: 1,
          groupId: 'null',
          warehouseId,
        })

        if (resInv?.data?.totalItems > resInv?.data?.items?.length) {
          const updatedResInv = await getInventory({
            isForTransaction: 1,
            size: resInv?.data?.totalItems,
            groupId: 'null',
            warehouseId,
          })

          if (updatedResInv?.data) {
            resInv = updatedResInv
          }
        }

        let resPacking = await getPacking({
          isForTransaction: 1,
          warehouseId,
        })
        if (resPacking?.data?.totalItems > resPacking?.data?.items?.length) {
          const updatedResPacking = await getPacking({
            isForTransaction: 1,
            size: resPacking?.data?.totalItems,
            warehouseId,
          })
          if (updatedResPacking?.data) {
            resPacking = updatedResPacking
          }
        }

        const packingItems = resPacking?.data?.items || []
        const invItems = resInv?.data?.items || []

        const optionsList = []

        if (packingItems.length > 0) {
          optionsList.push({
            label: 'GRUP INVENTORI',
            options: packingItems.map((e) => ({
              id: e?.id,
              value: e?.id,
              label: e?.label || e?.name || e?.nameItem,
              nameItem: e?.label || e?.name || e?.nameItem,
              amount: e?.amount,
              unit: e?.unit,
              isPacking: true,
              searchableText: String(e?.label || e?.name || e?.nameItem || ''),
            })),
          })
        }

        if (invItems.length > 0) {
          optionsList.push({
            label: 'SEMUA INVENTORI',
            options: invItems.map((e) => {
              const name = e?.item?.nameItem || e?.nameItem || ''
              const unit = e?.unit || e?.item?.unit || ''
              const ownerCode = e?.ownerCode || '-'
              const lotCodes =
                e?.lots
                  ?.map((lot) => lot?.codeLot || lot?.lotCode)
                  .filter(Boolean)
                  .join(', ') || '-'
              const photo = e?.item?.linkFoto || e?.linkFoto
              return {
                id: e?.id,
                value: e?.id,
                label: name,
                nameItem: name,
                amount: e?.amount,
                transferAmount: e?.amount,
                unit,
                ownerCode,
                lotCode: lotCodes,
                lots: e?.lots,
                photo,
                linkFoto: photo,
                isPacking: false,
                searchableText: String(name),
              }
            }),
          })
        }

        setListOptions(optionsList)
      } catch (error) {
        // error handling
      } finally {
        setIsInventoryLoading(false)
      }
    },
    [getInventory, getPacking],
  )

  useEffect(() => {
    let isMounted = true
    setLoading(true)

    const fetchData = async () => {
      try {
        let resGudangAsal = await getGudang({ isForFilter: 1 })
        if (
          isMounted &&
          resGudangAsal?.data?.totalItems > resGudangAsal?.data?.items?.length
        ) {
          const updatedResGudangAsal = await getGudang({
            isForFilter: 1,
            size: resGudangAsal?.data?.totalItems,
          })
          if (updatedResGudangAsal?.data) {
            resGudangAsal = updatedResGudangAsal
          }
        }
        if (isMounted) {
          setListOptionsOriginatingWarehouse(resGudangAsal?.data?.newData)
        }
        let resGudang = await getGudang({ isForTransfer: 1 })
        if (
          isMounted &&
          resGudang?.data?.totalItems > resGudang?.data?.items?.length
        ) {
          const updatedResGudang = await getGudang({
            isForTransfer: 1,
            size: resGudang?.data?.totalItems,
          })
          if (updatedResGudang?.data) {
            resGudang = updatedResGudang
          }
        }
        if (isMounted) {
          setListOptionsWarehouse(resGudang?.data?.newData)
        }
      } catch (error) {
        if (isMounted) {
          setErrMsg(error?.message ?? 'Gagal mengambil data')
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [getGudang])

  useEffect(() => {
    if (payload?.fromWarehouse) {
      fetchInv(payload.fromWarehouse.id ?? 'null')
    } else {
      setListOptions([])
    }
  }, [payload?.fromWarehouse?.value, fetchInv])

  // ─── Handle prefilled data from navigation state ────────────
  useEffect(() => {
    if (location.state) {
      const { fromWarehouse, transferItems } = location.state
      if (fromWarehouse) {
        const warehouseId =
          fromWarehouse.id ?? fromWarehouse.value ?? fromWarehouse.warehouseId
        const normalizedWarehouse = {
          ...fromWarehouse,
          value: warehouseId,
          label: fromWarehouse.name || fromWarehouse.label,
          id: warehouseId,
        }
        setPayload((prev) => ({
          ...prev,
          fromWarehouse: normalizedWarehouse,
        }))
      }

      if (Array.isArray(transferItems) && transferItems.length > 0) {
        const initialPics = transferItems.map((item) => formatItemForPic(item))
        setPics(initialPics)

        // Load members for any prefilled group items
        initialPics.forEach((item, idx) => {
          if (item?.isPacking && item?.id) {
            loadGroupMembers(item.id, idx)
          }
        })
      }
    }
  }, [location.state, formatItemForPic, loadGroupMembers])

  // Sync fromWarehouse object reference once listOptionsOriginatingWarehouse loads
  useEffect(() => {
    if (!payload?.fromWarehouse || !listOptionsOriginatingWarehouse?.length)
      return

    const currentWarehouse = payload.fromWarehouse
    const currentId =
      currentWarehouse.id ??
      currentWarehouse.value ??
      currentWarehouse.warehouseId
    const currentName = String(
      currentWarehouse.name ?? currentWarehouse.label ?? '',
    )
      .trim()
      .toLowerCase()
    const matched = listOptionsOriginatingWarehouse.find((warehouse) => {
      const optionId = warehouse.id ?? warehouse.value
      if (currentId !== undefined && currentId !== null && currentId !== '') {
        return String(optionId) === String(currentId)
      }
      const optionName = String(warehouse.name ?? warehouse.label ?? '')
        .trim()
        .toLowerCase()
      return currentName && optionName === currentName
    })

    if (matched && matched !== currentWarehouse) {
      setPayload((prev) => ({ ...prev, fromWarehouse: matched }))
    }
  }, [listOptionsOriginatingWarehouse, payload?.fromWarehouse])

  // Ensure originating and destination warehouses are never the same
  useEffect(() => {
    const fromId = payload?.fromWarehouse?.id ?? payload?.fromWarehouse?.value
    const toId = payload?.toWarehouse?.id ?? payload?.toWarehouse?.value
    if (fromId && toId && String(fromId) === String(toId)) {
      setPayload((prev) => ({
        ...prev,
        toWarehouse: null,
      }))
      enqueueSnackbar(
        'Gudang penerima direset karena tidak boleh sama dengan gudang pengirim.',
        { variant: 'warning' },
      )
    }
  }, [payload?.fromWarehouse, payload?.toWarehouse, enqueueSnackbar])

  // ─── Scanner event listener ──────────────────────────────────
  useEffect(() => {
    const handleScanEvent = (e) => {
      const { scannedValue } = e.detail || {}
      if (!scannedValue || !listOptions?.length) return

      const upperVal = scannedValue.toUpperCase()

      // Search through all inventory options
      for (const group of listOptions) {
        if (!group?.options) continue
        const matchedInv = group.options.find((opt) => {
          const searchText = (opt.searchableText || '').toUpperCase()
          const ownerCode = (opt.ownerCode || '').toUpperCase()
          const lotCode = (opt.lotCode || '').toUpperCase()
          const id = String(opt.id || opt.value || '').toUpperCase()
          return (
            searchText.includes(upperVal) ||
            ownerCode.includes(upperVal) ||
            lotCode.includes(upperVal) ||
            id === upperVal
          )
        })

        if (matchedInv) {
          const isAlreadySelected = pics.some(
            (p) =>
              p &&
              p.id === matchedInv.id &&
              Boolean(p.isPacking) === Boolean(matchedInv.isPacking),
          )
          if (!isAlreadySelected) {
            const emptyIdx = pics.findIndex(
              (pic) => !pic || pic === '' || !pic.id,
            )
            const targetIdx = emptyIdx >= 0 ? emptyIdx : pics.length

            handleSelectOption(targetIdx, matchedInv)
            enqueueSnackbar(`✅ Inventori dipilih`, { variant: 'success' })
            return
          }
        }
      }

      enqueueSnackbar(`Inventori tidak ditemukan: ${scannedValue}`, {
        variant: 'error',
      })
    }

    document.addEventListener('scanner:transfer-scan', handleScanEvent)
    return () => {
      document.removeEventListener('scanner:transfer-scan', handleScanEvent)
    }
  }, [listOptions, pics, enqueueSnackbar, handleSelectOption])

  const fromWarehouseId =
    payload?.fromWarehouse?.id ??
    payload?.fromWarehouse?.value ??
    payload?.fromWarehouse?.warehouseId
  const toWarehouseId =
    payload?.toWarehouse?.id ?? payload?.toWarehouse?.value
  const hasFromWarehouse =
    payload?.fromWarehouse !== null && payload?.fromWarehouse !== undefined
  const hasToWarehouse =
    payload?.toWarehouse !== null && payload?.toWarehouse !== undefined

  const isFormValid = Boolean(
    hasFromWarehouse &&
      hasToWarehouse &&
      fromWarehouseId !== undefined &&
      fromWarehouseId !== '' &&
      toWarehouseId !== undefined &&
      toWarehouseId !== '' &&
      String(fromWarehouseId) !== String(toWarehouseId) &&
      pics?.length > 0 &&
      pics?.every((pic) => pic && pic !== '' && pic.id) &&
      pics?.every((pic) => {
        if (pic.isPacking) {
          if (
            pic.loadingItems ||
            !Array.isArray(pic.items) ||
            pic.items.length === 0
          ) {
            return false
          }
          return pic.items.every((m) => {
            const rawVal =
              m.transferAmount !== undefined ? m.transferAmount : m.amount
            if (rawVal === '' || rawVal === null || rawVal === undefined) {
              return false
            }
            const val = parseFloat(rawVal) || 0
            const max = parseFloat(m.amount) || 0
            return val > 0 && val <= max
          })
        }
        const rawVal =
          pic.transferAmount !== undefined ? pic.transferAmount : pic.amount
        if (rawVal === '' || rawVal === null || rawVal === undefined) {
          return false
        }
        const val = parseFloat(rawVal) || 0
        const max = parseFloat(pic.amount) || 0
        return val > 0 && val <= max
      }),
  )

  return (
    <>
      <Container className="custom-container d-flex flex-column gap-1 py-2">
        <div className="pt-3">
          <BreadCrumbs
            breadCrumbActive={'Kirim Inventori'}
            breadCrumbParent={'Transfer Inventori'}
            breadCrumbParentLink={URL_TRANSFER_INVENTORY}
          />
        </div>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <CardText tag="h5" className="pb-4">
              Kirim Inventori
            </CardText>

            {!hasPrefillData && !dismissPrefillAlert && (
              <div
                className="d-flex align-items-start justify-content-between p-3 mb-4 rounded-3 border"
                style={{
                  backgroundColor: '#FFFDF5',
                  borderColor: '#FEDF89',
                }}
                data-testid="tf-inv-fallback-alert"
              >
                <div className="d-flex align-items-start gap-2">
                  <AlertCircle
                    size={20}
                    color="#B54708"
                    className="flex-shrink-0 mt-1"
                  />
                  <div>
                    <span
                      className="fw-semibold text-dark"
                      style={{ fontSize: '0.9rem' }}
                    >
                      Tidak ada inventori yang dipilih sebelumnya
                    </span>
                    <p
                      className="text-secondary small mb-0 mt-1"
                      style={{ lineHeight: 1.4 }}
                    >
                      Formulir ini biasanya diakses dari menu <strong>Kelola Stok</strong> setelah memilih inventori. Anda tetap dapat melanjutkan dengan memilih gudang dan inventori secara manual di bawah, atau kembali ke Kelola Stok untuk memilih inventori yang ingin dipindahkan.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2 ms-3 flex-shrink-0">
                  <CustomButton
                    size="sm"
                    outline
                    color="primary"
                    className="text-nowrap"
                    onClick={() => navigate(URL_INVENTORY)}
                    data-testid="tf-inv-back-to-inventory-btn"
                  >
                    Pilih dari Kelola Stok
                  </CustomButton>
                  <Button
                    close
                    size="sm"
                    onClick={() => setDismissPrefillAlert(true)}
                    aria-label="Tutup"
                    style={{ fontSize: '0.9rem' }}
                  />
                </div>
              </div>
            )}

            <FormGroup>
              <Label className="fw-500">Gudang pengirim</Label>
              <PMBSelect
                value={payload?.fromWarehouse}
                onChange={(e) => {
                  setErrMsg('')
                  const selectedId = e?.id ?? e?.value
                  const currentToId =
                    payload?.toWarehouse?.id ?? payload?.toWarehouse?.value
                  if (
                    selectedId &&
                    currentToId &&
                    String(selectedId) === String(currentToId)
                  ) {
                    enqueueSnackbar(
                      'Gudang pengirim tidak boleh sama dengan gudang penerima.',
                      { variant: 'warning' },
                    )
                    return
                  }
                  setPayload((prev) => ({
                    ...prev,
                    fromWarehouse: e,
                  }))
                  setPics([])
                }}
                options={
                  listOptionsOriginatingWarehouse?.map((warehouse) => {
                    const wId = warehouse?.id ?? warehouse?.value
                    const toId =
                      payload?.toWarehouse?.id ?? payload?.toWarehouse?.value
                    const isSame = Boolean(toId && String(wId) === String(toId))
                    return {
                      ...warehouse,
                      isDisabled: isSame,
                      disabledReason: isSame
                        ? 'Dipilih sebagai gudang penerima'
                        : undefined,
                    }
                  }) ?? []
                }
                placeholder="Pilih gudang pengirim..."
                isDisabled={pics?.some((pic) => pic && pic.id)}
                isSearchable={true}
                filterOption={(option, inputValue) => {
                  if (!inputValue) return true
                  const label = option?.data?.label || ''
                  return String(label)
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                }}
                noOptionsMessage={() => 'Tidak ada gudang yang sesuai'}
                testId="tf-inv-form-warehouse-from-select"
              />
            </FormGroup>

            <FormGroup>
              <Label className="fw-500">Gudang penerima</Label>
              <PMBSelect
                isDisabled={!payload?.fromWarehouse}
                value={payload?.toWarehouse}
                onChange={(e) => {
                  setErrMsg('')
                  const selectedId = e?.id ?? e?.value
                  const currentFromId =
                    payload?.fromWarehouse?.id ?? payload?.fromWarehouse?.value
                  if (
                    selectedId &&
                    currentFromId &&
                    String(selectedId) === String(currentFromId)
                  ) {
                    enqueueSnackbar(
                      'Gudang penerima tidak boleh sama dengan gudang pengirim.',
                      { variant: 'warning' },
                    )
                    return
                  }
                  setPayload((prev) => ({
                    ...prev,
                    toWarehouse: e,
                  }))
                }}
                options={
                  listOptionsWarehouse?.map((warehouse) => {
                    const wId = warehouse?.id ?? warehouse?.value
                    const fromId =
                      payload?.fromWarehouse?.id ??
                      payload?.fromWarehouse?.value
                    const isSame = Boolean(
                      fromId && String(wId) === String(fromId),
                    )
                    return {
                      ...warehouse,
                      isDisabled: isSame,
                      disabledReason: isSame
                        ? 'Dipilih sebagai gudang pengirim'
                        : undefined,
                    }
                  }) ?? []
                }
                placeholder="Pilih gudang penerima..."
                isSearchable={true}
                filterOption={(option, inputValue) => {
                  if (!inputValue) return true
                  const label = option?.data?.label || ''
                  return String(label)
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                }}
                noOptionsMessage={() => 'Tidak ada gudang yang sesuai'}
                testId="tf-inv-form-warehouse-to-select"
              />
              {hasFromWarehouse &&
                fromWarehouseId !== undefined &&
                fromWarehouseId !== '' &&
                toWarehouseId &&
                String(fromWarehouseId) === String(toWarehouseId) && (
                  <div
                    className="d-flex align-items-center text-danger small mt-1 gap-1"
                    data-testid="tf-inv-warehouse-same-warning"
                  >
                    <AlertCircle size={14} />
                    <span>
                      Gudang penerima tidak boleh sama dengan gudang pengirim.
                    </span>
                  </div>
                )}
            </FormGroup>

            <FormGroup>
              <Label className="fw-500">Nomor Transfer</Label>
              <Input
                type="text"
                placeholder="Masukkan Nomor Transfer"
                value={payload?.transferNumber || ''}
                onChange={(e) => {
                  setErrMsg('')
                  setPayload((prev) => ({
                    ...prev,
                    transferNumber: e.target.value,
                  }))
                }}
              />
            </FormGroup>

            <FormGroup>
              <Label className="fw-500">Catatan</Label>
              <Input
                type="textarea"
                placeholder="Masukkan catatan"
                value={payload?.note || ''}
                onChange={(e) => {
                  setErrMsg('')
                  setPayload((prev) => ({
                    ...prev,
                    note: e.target.value,
                  }))
                }}
              />
            </FormGroup>

            {/* ─── INVENTORI YANG DIPINDAHKAN SECTION ───────────── */}
            <FormGroup>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Label className="fw-500 mb-0">
                  Inventori yang dipindahkan
                </Label>
                {pics?.length > 0 && payload?.fromWarehouse && (
                  <span className="text-muted small">
                    {pics.filter((p) => p && p.id).length} inventori dipilih
                  </span>
                )}
              </div>

              {!payload?.fromWarehouse ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center p-4 rounded mb-3 text-center"
                  style={{
                    backgroundColor: '#fcfcfd',
                    minHeight: '140px',
                    border: '1px dashed #EAECF0',
                  }}
                  data-testid="tf-inv-no-warehouse-notice"
                >
                  <AlertCircle size={28} className="text-muted mb-2" />
                  <span
                    className="fw-semibold text-secondary"
                    style={{ fontSize: '0.95rem' }}
                  >
                    Pilih Gudang Pengirim Terlebih Dahulu
                  </span>
                  <span className="text-muted small mt-1 mb-3">
                    Inventori yang dapat dipindahkan akan ditampilkan setelah
                    gudang pengirim dipilih.
                  </span>
                  <CustomButton
                    size="sm"
                    outline
                    color="secondary"
                    onClick={() => navigate(URL_INVENTORY)}
                    data-testid="tf-inv-go-to-inventory-notice-btn"
                  >
                    Atau Pilih Inventori dari Kelola Stok
                  </CustomButton>
                </div>
              ) : isInventoryLoading ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center p-4 rounded mb-3"
                  style={{
                    backgroundColor: '#fcfcfd',
                    minHeight: '140px',
                    border: '1px dashed #EAECF0',
                  }}
                  data-testid="tf-inv-loading-state"
                >
                  <div
                    className="spinner-border spinner-border-sm text-primary mb-2"
                    role="status"
                    style={{ width: '2rem', height: '2rem' }}
                  />
                  <span
                    className="fw-bold"
                    style={{ fontSize: '0.95rem', color: '#101828' }}
                  >
                    Menyiapkan Inventori
                  </span>
                  <span className="text-muted small">
                    Mohon tunggu, sedang memproses data inventori...
                  </span>
                </div>
              ) : pics?.length === 0 ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center p-4 rounded mb-3 text-center"
                  style={{
                    backgroundColor: '#fcfcfd',
                    minHeight: '150px',
                    border: '1px dashed #EAECF0',
                  }}
                  data-testid="tf-inv-empty-state"
                >
                  <Package size={30} className="text-muted mb-2" />
                  <span
                    className="fw-semibold text-dark"
                    style={{ fontSize: '0.95rem' }}
                  >
                    Belum Ada Inventori yang Dipilih
                  </span>
                  <span
                    className="text-muted small mb-3"
                    style={{ maxWidth: '420px' }}
                  >
                    Silakan klik tombol di bawah untuk menambahkan inventori
                    yang ingin dipindahkan dari gudang pengirim, atau kembali ke
                    Kelola Stok.
                  </span>
                  <div className="d-flex gap-2 flex-wrap justify-content-center">
                    <CustomButton
                      onClick={handleAdd}
                      outline
                      color="primary"
                      size="sm"
                      data-testid="tf-inv-add-first-item-btn"
                    >
                      <Plus size={16} /> Tambah Inventori
                    </CustomButton>
                    <CustomButton
                      onClick={() => navigate(URL_INVENTORY)}
                      color="secondary"
                      outline
                      size="sm"
                      data-testid="tf-inv-empty-back-inventory-btn"
                    >
                      Pilih dari Kelola Stok
                    </CustomButton>
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-column">
                  {pics?.map((pic, index) => (
                    <TransferInventoryItem
                      key={
                        pic?.id
                          ? `${pic.isPacking ? 'group' : 'inventory'}-${pic.id}-${index}`
                          : `slot-${index}`
                      }
                      item={pic}
                      index={index}
                      options={getFilteredOptions() ?? []}
                      onSelect={handleSelectOption}
                      onRemove={handleDelete}
                      onAmountChange={handleAmountChange}
                      onGroupItemAmountChange={handleGroupItemAmountChange}
                      onToggleGroup={handleToggleGroup}
                      formatAmount={formatAmount}
                      intl={intl}
                    />
                  ))}

                  <div className="mt-1 mb-2">
                    <CustomButton
                      onClick={handleAdd}
                      outline
                      color={
                        !payload?.toWarehouse ||
                        !payload?.fromWarehouse ||
                        pics?.some((pic) => !pic || pic === '' || !pic.id)
                          ? ''
                          : 'primary'
                      }
                      size="sm"
                      disabled={
                        !payload?.toWarehouse ||
                        !payload?.fromWarehouse ||
                        pics?.some((pic) => !pic || pic === '' || !pic.id)
                      }
                      data-testid="tf-inv-form-add-item-button"
                    >
                      <Plus size={16} /> Tambah Inventori
                    </CustomButton>
                  </div>
                </div>
              )}
            </FormGroup>

            <hr />

            {errMsg && (
              <FormGroup>
                <small className="text-danger">
                  <AlertCircle size={15} /> {errMsg}
                </small>
              </FormGroup>
            )}

            <div className="d-flex gap-3">
              <Button
                className="btn-cancel"
                onClick={() => navigate(URL_TRANSFER_INVENTORY)}
                outline
                block
              >
                Batal
              </Button>
              <CustomButton
                onClick={() => setShowConfirmModal(true)}
                disabled={
                  resultTransfer?.isLoading ||
                  loading ||
                  pics?.some((p) => p?.loadingItems) ||
                  !isFormValid
                }
                block
                color="primary"
                testId="tf-inv-submit-button"
              >
                Kirim Inventori
              </CustomButton>
            </div>
          </CardBody>
        </Card>

        {/* Confirmation Modal before Submit */}
        <Modal
          isOpen={showConfirmModal}
          toggle={() => setShowConfirmModal(false)}
          centered
          data-testid="modal-confirm-submit-transfer"
        >
          <div className="regular-padding-horizontal small-scrollable-container small-padding-vertical">
            <h5 className="fw-semibold mb-2">
              Konfirmasi Pengiriman Inventori
            </h5>
            <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
              Pastikan data transfer inventori sudah sesuai sebelum melanjutkan.
            </p>
            <div className="p-3 bg-light rounded border mb-2">
              <div className="mb-2">
                <small className="text-muted d-block">Gudang Pengirim:</small>
                <span className="fw-semibold text-dark">
                  {payload?.fromWarehouse?.label ||
                    payload?.fromWarehouse?.name ||
                    '-'}
                </span>
              </div>
              <div className="mb-2">
                <small className="text-muted d-block">Gudang Penerima:</small>
                <span className="fw-semibold text-dark">
                  {payload?.toWarehouse?.label ||
                    payload?.toWarehouse?.name ||
                    '-'}
                </span>
              </div>
              {payload?.transferNumber && (
                <div className="mb-2">
                  <small className="text-muted d-block">Nomor Transfer:</small>
                  <span className="fw-semibold text-dark">
                    {payload?.transferNumber}
                  </span>
                </div>
              )}
              <div>
                <small className="text-muted d-block">
                  Jumlah Inventori/Grup:
                </small>
                <span className="fw-semibold text-dark">
                  {pics?.filter((p) => p && p.id)?.length || 0} item
                </span>
              </div>
            </div>
          </div>
          <div className="regular-padding-horizontal regular-padding-bottom d-flex justify-content-between mt-2">
            <CustomButton
              onClick={() => setShowConfirmModal(false)}
              outline
              disabled={resultTransfer?.isLoading}
              className="fw-semibold btn-cancel"
              style={{
                width: '49%',
                borderColor: '#D0D5DD',
                color: '#344054',
              }}
            >
              Batal
            </CustomButton>
            <CustomButton
              onClick={() => {
                setShowConfirmModal(false)
                handleSubmit()
              }}
              disabled={resultTransfer?.isLoading}
              className="fw-semibold"
              color="primary"
              style={{ width: '49%' }}
              testId="btn-confirm-submit-transfer"
            >
              {resultTransfer?.isLoading ? 'Mengirim...' : 'Kirim Sekarang'}
            </CustomButton>
          </div>
        </Modal>
      </Container>
    </>
  )
}

export default FormTransferInventory
